import { type EditorSDK, EventType } from '@wix/platform-editor-sdk';

import { updateLoginBarMenuItemsLabels } from '../services/menu';

export const addPageRenamedListener = async (editorSDK: EditorSDK) => {
  return editorSDK.addEventListener(EventType.pageRenamed, async (event) => {
    const { pageRef, title } = event.detail;
    await updateLoginBarMenuItemsLabels(editorSDK, pageRef, title);
  });
};
